import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MdLogout, MdPerson, MdRefresh } from 'react-icons/md';
import { useAuthStore } from '@/features/auth/store/useAuth';


interface HeaderProps {
  title?: string;
  onRefresh?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ title, onRefresh }) => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="h-14 bg-white border-b border-gray-100 px-6 flex items-center justify-between sticky top-0 z-10">
      {/* Page title */}
      <h1 className="text-sm font-semibold text-gray-800">{title ?? 'Dashboard'}</h1>

      <div className="flex items-center gap-3">
        {/* Refresh button */}
        {onRefresh && (
          <button
            onClick={onRefresh}
            className="p-1.5 text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors"
            title="Refresh"
          >
            <MdRefresh size={18} />
          </button>
        )}

        {/* User info */}
        <div className="flex items-center gap-2 pl-3 border-l border-gray-100">
          <div className="w-7 h-7 bg-indigo-100 rounded-full flex items-center justify-center">
            <MdPerson size={16} className="text-indigo-600" />
          </div>
          <span className="text-xs font-medium text-gray-700">
            {user?.username ?? 'User'}
          </span>
        </div>

        {/* Logout */}
        <button
          onClick={handleLogout}
          className="flex items-center gap-1.5 text-xs text-gray-400 hover:text-red-500 transition-colors px-2 py-1.5 rounded-lg hover:bg-red-50"
        >
          <MdLogout size={15} />
          Logout
        </button>
      </div>
    </header>
  );
};